export default __webpack_public_path__ + "static/media/marker.3899d8ab.png";